let IlPartner = (props) => {
  let lot = props.lot;	
  let tr = props.tr;
  
  // Safely extract treatment string if it's an array or a value
  let tTxt = Array.isArray(tr) ? tr[0] : tr;
  let tTxtLower = (typeof tTxt === 'string') ? tTxt.toLowerCase() : '';
  
  if(tTxtLower === "expedry"){
    //return(<div className="tech-partner"><a href={`//fuze47.com/?ref=tmd-com&lot=${lot}`}
    return(<div className="tech-partner"><a href={`//alliedfeather.com/innovation/expedry?ref=tmd-com&lot=${lot}`} target="_blank"></a></div>);	  	    
  } else {
    return(<></>);
  }
} 

export { IlPartner }